import { Link } from "react-router-dom";
import type { IntegrationLogReferenceProps } from "../types/integration-logs.types";
import { EMPTY_CELL } from "../services/integration-log-format";

/** `entityType` value that carries an admin order page we can deep-link to. */
const ORDER_ENTITY_TYPE = "order";

/**
 * Renders the log's business reference. When the row points at an order that
 * we can actually resolve (both the store and the order id are present), the
 * reference becomes a deep link into the admin order page; otherwise it stays
 * plain text so a partially-populated row never produces a broken URL.
 */
export function IntegrationLogReference({
  locale,
  reference,
  entityType,
  entityId,
  storeId,
  stopRowPropagation = false,
}: IntegrationLogReferenceProps) {
  const label = reference?.trim() || entityId?.trim() || "";
  const isOrderLink =
    entityType === ORDER_ENTITY_TYPE &&
    Boolean(storeId?.trim()) &&
    Boolean(entityId?.trim());

  if (!label) {
    return <span style={{ color: "var(--rd-text-meta)" }}>{EMPTY_CELL}</span>;
  }

  if (!isOrderLink) {
    return (
      <span className="rd-cell-sub" style={{ display: "block", fontSize: 13, color: "var(--rd-text-secondary)" }}>
        {label}
      </span>
    );
  }

  return (
    <Link
      to={`/${locale}/admin/stores/${storeId}/orders/${entityId}`}
      onClick={
        stopRowPropagation ? (event) => event.stopPropagation() : undefined
      }
      style={{
        display: "block",
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        color: "var(--rd-primary)",
        fontWeight: 500,
        textDecoration: "none",
      }}
    >
      {label}
    </Link>
  );
}
